export default __webpack_public_path__ + "static/media/mh.554fb812.svg";